<template>
  <div class="page-container">
    <van-radio-group class="radio-group" @change="radioGroupOnChange" v-model="isSelectAllGoods" direction="horizontal">
      <van-radio
        :icon-size="transPxToRem(18)"
        :name="Boolean(item.value)"
        v-for="item in [
          { label: '全部商品', value: 1 },
          { label: '选择商品', value: 0 }
        ]"
        :key="item.value"
        >{{ item.label }}</van-radio
      >
    </van-radio-group>
    <template v-if="!isSelectAllGoods">
      <div class="divider-line"><div class="divider-line van-hairline--bottom"></div></div>
      <SearchBar
        @search="search"
        @focus="isShowBottomBtn = false"
        @blur="isShowBottomBtn = true"
        v-model="postListParams.goodsName"
        placeholder="请输入商品名称查询"
      />
      <van-list
        class="list-container"
        v-model:loading="loading"
        :finished="finished"
        :finished-text="finishedText"
        :immediate-check="false"
        @load="getList"
      >
        <div v-for="item in list" :key="item.goodsId" class="list-item-wrp">
          <GoodsItem
            class="list-item-content"
            @checkbox-change="onCheckboxChange"
            v-bind="{
              goodsId: item.goodsId,
              goodsImage: item.goodsPic,
              goodsName: item.goodsName,
              goodsPrice: item.salePrice,
              goodsCount: 1,
              goodsCoverSize: 80,
              hasCheckBox: true,
              isSelect: selectedGoodsIds.includes(item.goodsId)
            }"
          />
        </div>
      </van-list>
      <van-empty
        image-size="240"
        image="https://i.xurl.cn/x_dsx_wxapp/empty/goods.png"
        v-if="list.length == 0 && !loading"
        description="暂无商品"
      />
    </template>
    <transition name="van-fade">
      <div class="selected-float-box" v-if="selectGoodsNum && !isSelectAllGoods" @click="showSelected = true">
        <span class="selected-text-label">已选</span>
        <span class="selected-num">({{ selectGoodsNum }})</span>
      </div>
    </transition>
    <div class="bottom-btn-wrp">
      <van-button @click="submit" color="linear-gradient( 170deg, #FFB695 0%, #FD7F5C 100%)" round block type="primary"
        >提交</van-button
      >
    </div>
    <ActionSheet v-model:show="showSelected" title="已选商品">
      <div class="list-item-wrp" :key="item.goodsId" v-for="item in selectedGoods">
        <GoodsItem
          @delete="deleteSelectedGoodsItem"
          v-bind="{
            goodsId: item.goodsId,
            goodsImage: item.goodsPic,
            goodsName: item.goodsName,
            goodsPrice: item.salePrice,
            goodsCount: 1,
            goodsCoverSize: 70,
            hasDelIcon: true
          }"
        />
      </div>
    </ActionSheet>
    <back-top />
  </div>
</template>
<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
// import { useCssVar } from '@vueuse/core'
// import { getLocal } from '@/common/js/utils'
import { useRouter } from 'vue-router'
// import { useUserStore } from '@/store/user'

import { ActionSheet, showToast } from 'vant'
import { getGoodsSimpleList } from '@/api/goods/'
import { transPxToRem } from '@/utils'
import { SearchBar, BackTop } from '@/components'
import { GoodsItem } from './component'
import usePage from '@/hooks/usePage'
const { navigateBack } = usePage()

const router = useRouter()
const { currentRoute } = router
const query = currentRoute.value.query
const { rankType } = query
const goodsIds = query?.goodsIds ? query?.goodsIds.split(',') : []

const isSelectAllGoods = ref(goodsIds.length === 0)
const isShowBottomBtn = ref(true)
const postListParams = reactive({
  page: 1,
  pageSize: 20,
  goodsName: ''
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const selectedGoods = ref([])
const showSelected = ref(false)

const selectedGoodsIds = computed(() => selectedGoods.value.map(d => d.goodsId))
const selectGoodsNum = computed(() => selectedGoodsIds.value.length)
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const radioGroupOnChange = val => !val && search()

const reset = () => {
  list.value = []
  postListParams.page = 1
}
const search = () => {
  reset()
  getList()
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await getGoodsSimpleList(postListParams)
    list.value.push(...resData.list)
    postListParams.page++
    finished.value = list.value.length === Number(resData.total)
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const deleteSelectedGoodsItem = goodsId => {
  selectedGoods.value = selectedGoods.value.filter(d => d.goodsId != goodsId)
  if (selectedGoods.value.length === 0) {
    showSelected.value = false
  }
}

const onCheckboxChange = ({ checked, goodsId }) => {
  if (checked) {
    const goodsItem = list.value.filter(d => d.goodsId == goodsId)[0]
    selectedGoods.value.push(goodsItem)
  } else {
    deleteSelectedGoodsItem(goodsId)
  }
}

const submit = () => {
  if (!isSelectAllGoods.value && selectGoodsNum.value === 0) {
    showToast('请选择商品')
    return false
  }
  navigateBack(
    { refresh: true },
    `/agentRank?rankType=${rankType}&goodsIds=${isSelectAllGoods.value ? [] : selectedGoodsIds.value}`
  )
}

const getSelectedGoods = async () => {
  try {
    const resData = await getGoodsSimpleList({ goodsIds, page: 1, pageSize: 500 })
    selectedGoods.value.push(...resData.list)
  } catch (e) {
    console.log(e)
  }
}

// const userStore = useUserStore()
// const primaryColor = useCssVar('--van-primary-color', document.documentElement)
// const theme = computed(() => userStore.getTheme)

onMounted(() => {
  if (!isSelectAllGoods.value) {
    getList()
    getSelectedGoods()
  }
  // primaryColor.value = theme.value.PrimaryButtonColor
})

// const onLoad = () => {}
</script>
<style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 10px);
  margin-top: 10px;
  padding-top: 16px;
  background-color: var(--van-white);
  font-size: 14px;
  .divider-line {
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .list-container {
    padding-bottom: 60px;
    margin-top: 20px;
    background-color: var(--van-white);
  }

  .radio-group {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    .van-radio {
      width: calc(50% - var(--van-padding-sm));
    }
  }

  .selected-float-box {
    position: fixed;
    border-radius: 50%;
    right: 10px;
    bottom: 70px;
    width: 48px;
    height: 48px;
    background: var(--van-white);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    opacity: 0.98;
    color: var(--van-primary-color);
    font-size: 12px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .selected-num {
      display: block;
      font-weight: 400;
    }
  }

  .bottom-btn-wrp {
    position: fixed;
    width: 100%;
    padding: 10px 16px;
    bottom: 0;
    left: 0;
    background-color: var(--van-white);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
  }
  .list-item-wrp {
    padding: 0 16px 16px 16px;
    background-color: var(--van-white);
    + .list-item-wrp {
      margin-top: 5px;
    }
  }
}
</style>
